/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminListJoinedMoneyPools} from '../api'

export const useMutationAdminListJoinedMoneyPools = createReactQueryMutationHook('adminListJoinedMoneyPools', adminListJoinedMoneyPools)
